const loadCookieConsent = (domain, config) => {
  const initCookieConsent = () => {
    window.CookieConsentConfig = config;

    const style = document.createElement('link');
    style.setAttribute('rel', 'stylesheet');
    style.setAttribute('href', `${domain}/cookie-consent.css`);
    document.head.appendChild(style);

    const script = document.createElement('script');
    script.setAttribute('src', `${domain}/cookie-consent.umd.js`);
    document.head.appendChild(script);
  };

  if (document.readyState === 'complete') {
    initCookieConsent();
  } else {
    window.addEventListener('load', initCookieConsent);
  }
};

const cookieConsentConf = (config) => {
  const domain = {
    development: 'https://cookie-consent-homolog.quero.space',
    homolog: 'https://cookie-consent-homolog.quero.space',
    production: 'https://cookie-consent-prod.quero.space',
  }[process.env.NODE_ENV];

  loadCookieConsent(domain, config);
};

const cookieConsent = () => cookieConsentConf({
  systemCode: process.env.QP_FRONT_SYS_CODE,
  customClassNames: {
    button: 'z-button z-button--primary',
  },
  trackable: false,
  cookieDomain: null,
  linkUrl: 'https://querobolsa.com.br/ajuda/politica-de-cookies',
});

export default cookieConsent;
